import { resolveWizardResumeStep } from '../OnboardingWizard/wizardProgress';

export { resolveWizardResumeStep };

export function routeForRow(listing, opts = {}) {
    const editSuffix = opts.edit ? '?edit=1' : '';
    return `/dashboard/my-properties/${listing._id}${editSuffix}`;
}

export function routeForEditFromDrawer(listing, opts = {}) {
    const editFlag = opts.edit ? '?edit=1' : '';
    const step = resolveWizardResumeStep(listing);
    return `/dashboard/listings/edit/${listing._id}/${step}${editFlag}`;
}
